var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUniqueIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2138_114570)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2138_114570)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.1999,
    cy: 17.8,
    r: 13.8,
    fill: "#FD00EE"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2138_114570)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.1999,
    cy: 26.0002,
    r: 13.8,
    fill: "#02BFEC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2138_114570)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.8,
    cy: 17.2004,
    r: 13.8,
    fill: "#8BD448"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_2138_114570)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.5998,
    cy: 4.0002,
    r: 13.8,
    fill: "#FAE442"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter4_f_2138_114570)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.0002,
    cy: 4.0002,
    r: 13.8,
    fill: "#FF1619"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 4.5,
    stroke: "#202329",
    strokeOpacity: 0.17
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2138_114570",
    x: -26.6001,
    y: -11,
    width: 57.6001,
    height: 57.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_2138_114570"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2138_114570",
    x: -13.6001,
    y: -2.7998,
    width: 57.6001,
    height: 57.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_2138_114570"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2138_114570",
    x: -1,
    y: -11.5996,
    width: 57.6001,
    height: 57.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_2138_114570"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2138_114570",
    x: -3.2002,
    y: -24.7998,
    width: 57.6001,
    height: 57.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_2138_114570"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_2138_114570",
    x: -24.7998,
    y: -24.7998,
    width: 57.6001,
    height: 57.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_2138_114570"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2138_114570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniqueIcon);
export default __webpack_public_path__ + "static/media/unique-icon.4818dc18db7357d72aea51420d49e60b.svg";
export { ForwardRef as ReactComponent };